<script lang="ts">
    import { _ } from "svelte-i18n";
    import { StaticLoader } from "../helpers/static";
</script>

<div class="container min-h-full lg:max-w-[60%] mx-auto px-4 overscroll-auto bg-primary pt-1 pb-1">

        <svelte:component this={StaticLoader('publication', $_('code'))} />

</div>